import React from 'react';

export default function LiveSessionTime({ content, onBecomeLive = () => {}, showCountDownOnLive = false }) {
  // Don't even build the component if the config is set to hide it
  //@ts-ignore
  if (CrowdHub_App.CONFIG.HIDE_LIVE_SESSION_TIMER) {
    return <></>;
  }

  const [sessionState, setSessionState] = React.useState(content.currentState());
  const [time, setTime] = React.useState(content.formatCountdown());

  let display;
  let displayClass = '';
  switch (sessionState) {
    //@ts-ignore
    case JunoContent.STATE_LIVE:
      display = (
        <>
          <span>LIVE </span>
          <img
            //@ts-ignore
            src={App.INSTANCE.getAssetsSrc(
              //@ts-ignore
              Resources.resources.IMG_LIVE_BUTTON.src,
            )}
          />
          {showCountDownOnLive && <span className={`time`}>{time}</span>}
        </>
      );
      displayClass = 'live';
      break;
    //@ts-ignore
    case JunoContent.STATE_PAST:
      display = 'PAST';
      displayClass = 'past';
      break;
    //@ts-ignore
    case JunoContent.STATE_UPCOMING:
      display = time;
      displayClass = 'upcoming';
      break;
    default:
      display = time;
  }

  React.useEffect(() => {
    // Re-renders the page UNLESS the state is past
    if (
      //@ts-ignore
      sessionState == JunoContent.STATE_UPCOMING ||
      //@ts-ignore
      sessionState == JunoContent.STATE_LIVE
    ) {
      let aInterval = setInterval(() => {
        setTime(content.formatCountdown());

        if (content.currentState() !== sessionState) {
          setSessionState(content.currentState());
          // Let's the world know that we are live. OnBecomeLive can be whatever it wants based on the component using LiveSessionTime.js
          //@ts-ignore
          if (content.currentState() == JunoContent.STATE_LIVE) {
            onBecomeLive();
          }
        }
      }, 1000);
      return () => {
        // Prevents infinite aInterval objects
        clearInterval(aInterval);
      };
    }
  });

  return (
    <div className={`livesession_time ${displayClass}`} style={{ display: 'block' }}>
      {display}
    </div>
  );
}
